import { render, staticRenderFns } from "./UserShare.vue?vue&type=template&id=075ef0a5&scoped=true"
import script from "./UserShare.vue?vue&type=script&lang=js"
export * from "./UserShare.vue?vue&type=script&lang=js"
import style0 from "./UserShare.vue?vue&type=style&index=0&id=075ef0a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075ef0a5",
  null
  
)

export default component.exports